import { render } from "./dictType.vue?vue&type=template&id=e61e3bde"
import script from "./dictType.vue?vue&type=script&lang=js"
export * from "./dictType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__